<template>
	<div class="artist-split2-content">
		<b-row class="banner">
			<!-- <transition mode="out-in">
				<div class="scroll-banner" v-show="scrolled > 76">
					<h3 class="name-ch">{{ this.artist.nameCh }}</h3>
					<h3 class="name-en">{{ this.artist.nameEn }}</h3>
					<div class="right2">
						<h3 class="time">駐村時程&emsp;{{ this.artist.stayTime }}</h3>
						<h3 class="city">
							國籍&emsp;{{ this.artist.cityCh + "·" + this.artist.city }}
						</h3>
					</div>
					<img
						@click="closeSlide"
						class="close"
						src="@/assets/about/corner/btn_back.svg"
						alt=""
					/>
				</div>
			</transition> -->

			<img
				@click="closeSlide"
				class="close"
				src="@/assets/about/corner/btn_back.svg"
				alt=""
			/>

			<b-col
				class="col-lg-6 col-sm-12 col-12 left banner-item"
				style="position:relative;"
			>
				<img :src="artist.contentImg" width="100%" />
			</b-col>
			<b-col class="col-lg-6 col-sm-12 col-12 right banner-item">
				<div
					class="banner-box"
					style="left: 0; right: 0; width: 100%; height: 100%; padding: 45px;overflow-y: auto;"
				>
					<h3 class="name-ch">{{ artist.nameCh }}</h3>
					<h3 class="name-en">{{ artist.nameEn }}</h3>
					<br />
					<h3 class="time">
						駐村時程：
						<pre
							style="color:inherit; display:inline-block; vertical-align:top;"
							>{{ artist.stayTime }}</pre
						>
					</h3>
					<h3 class="city">國籍：{{ artist.cityCh + "·" + artist.city }}</h3>
					<br />
					<h3 class="abstract" v-html="artist.abstract"></h3>
				</div>
			</b-col>
		</b-row>
		<div class="content" v-html="artist['content-about']"></div>
	</div>
</template>

<script>
import ArtistData from "../../static/assets/program/artistData.json";
export default {
	name: "artistSplit2Content",
	data() {
		return {
			sliding: 0,
			scrolled: 0,
			artistList: ArtistData,
			artist: {},
			counter: 0
		};
	},
	methods: {
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
		closeSlide() {
			this.$router.push("/program/list");
		},
		handleScroll() {
			this.scrolled = window.scrollY;
		}
	},
	components: {},
	created() {
		this.artist = _.find(this.artistList, {
			id: parseInt(this.$route.params.id)
		});
		window.addEventListener("scroll", this.handleScroll);
		this.counter += 1;
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	}
};
</script>

<style lang="scss">
b {
	font-weight: bold !important;
}
.grid{
	width: 100%;
	display: grid;
	grid-template-columns: repeat(1, minmax(0, 1fr));
	gap: 0.5rem;
	img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
.banner-box{
	position: relative;
}
@media screen and (min-width: 769px){
	.grid{
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
	.banner-box{
		position: absolute;
	}
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../stylesheet/base.sass'
@import '../stylesheet/layout.sass'

.artist-split2-content
  overflow: hidden
  position: relative
  width: 100%
  z-index: 500
  top: 0
  left: 0
  .scroll-banner
    +flexLayout('start', 'row')
    position: fixed
    top: 76px
    left: 0
    width: 100%
    height: 120px
    z-index: 100
    background-color: #222222
    color: white
    padding: 0 130px
    flex-wrap: wrap
    @media screen and (max-width: 990px)
      top: 91px
      +flexLayout('start', 'col')
      flex-wrap: wrap
      height: initial
      padding: 20px 5px
    .title
      font-size: 24px !important
    .close
      +size(30px, 30px)
      position: absolute
      right: 50px
      top: 25px !important
      z-index: 500
      opacity: 1
      @media screen and (max-width: 990px)
        right: 30px
        top: 5px
    .name-ch
      font-size: 20px
      margin-right: 10px
      @media screen and (max-width: 990px)
        margin-left: 30px
    .name-en
      font-size: 18px
      border: 0px solid #01b3de
      border-left-width: 1px
      padding-left: 20px
      @media screen and (max-width: 990px)
        margin-left: 30px
        margin-top: 10px
        margin-bottom: 20px
    .right2
      font-weight: 200
      line-height: 2
      margin-left: 30px
  .banner
    .banner-item
      line-height: 2
      letter-spacing: 2px
      .time
        font-weight: 200
        font-size: 14px
      .city
        font-weight: 200
        font-size: 14px
      .abstract
        font-weight: 200
        font-size: 14px
      #carousel1
        .carousel-inner
          width: 100%
          height: 480px
        .carousel-item
          background-size: cover
          background-position: 50% 50%
          height: 480px
          width: 100%
        .item1
          background-image: url('/static/assets/program/image/img_d_artist_16_Canivet.png')
      @media screen and (max-width:900px)
        height: 100%
        #carousel1
          .carousel-inner
            width: 100%
            height: 300px
          .carousel-item
            width: 100%
            height: 300px
    .left
      padding: 0
    .right
      background-color: $themeGray
      color: $white
      font-weight: 300
      .title
        font-size: $font-size-3
        margin: 20px 0
      .content
        font-size: $font-size-3-s
        line-height: 1.5
        letter-spacing: 3px

  .close
    +size(30px, 30px)
    position: absolute
    right: 50px
    top: 50px
    z-index: 500
    opacity: 1
    @media screen and (max-width: 990px)
      top: 40px
      right: 26px
  .content
    max-width: 1200px
    margin: 0 auto 60px
    background-color: white
    padding: 50px 130px 120px 130px
    font-size: $font-size-3
    line-height: 1.5
    // min-height: 1000px

  @media all and (max-width: 800px)
    .content
      padding: 50px 30px
</style>



// WEBPACK FOOTER //
// src/components/artist_split2_content.vue